import { useCallback, useEffect } from 'react';
import { faBell } from '@fortawesome/pro-solid-svg-icons/faBell';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';

import { Button } from '../../../ui-components/components/button';
import { THEME_CONSTANTS } from '../../../ui-components/services/button-theme-service';
import { FlexRow } from '../../../ui-components/components/flex/row';
import Global from '../../../store/global-selectors';
import { fetchNotificationsRequest, toggleNotificationHub } from '../../../store/notification-hub/notification-hub.actions';
import { toggleLabelQue } from '../../../store/label-que/label-que.actions';
import { Segment } from '../../../services/analytics-services/segment';
import { ALERTS_PANEL_OPENED } from '../../../constants/analytics-events';
import baseStyle from '../app-header.module.less';
import { appHeaderMessages } from '../messages';
import style from './notification-bell-button.module.less';

const MAX_DISPLAYED_UNREAD_COUNT = 99;
const OVERFLOW_LABEL = '99+';

export const NotificationBellButton = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const isNotificationHubOpen = useSelector(Global.selectNotificationHubIsOpen);
  const unreadCount = useSelector(Global.selectNotificationHubUnreadCount);

  useEffect(() => {
    dispatch(fetchNotificationsRequest());
  }, [dispatch]);

  const handleNotificationBellClick = useCallback(() => {
    if (!isNotificationHubOpen) {
      Segment.trackEvent(ALERTS_PANEL_OPENED);
      dispatch(toggleLabelQue(false));
    }
    dispatch(toggleNotificationHub(!isNotificationHubOpen));
  }, [dispatch, isNotificationHubOpen]);

  return (
    <div className={baseStyle['menu-item']} title={intl.formatMessage(appHeaderMessages.notificationHubTitle)}>
      <Button
        ariaLabel={intl.formatMessage(appHeaderMessages.notificationHubTitle)}
        className={baseStyle['icon-wrapper']}
        onClick={handleNotificationBellClick}
        theme={THEME_CONSTANTS.unstyled}
      >
        <FontAwesomeIcon className={baseStyle['menu-item-icon']} icon={faBell} />
        {unreadCount > 0 && (
          <FlexRow className={style['unread-badge']}>{unreadCount > MAX_DISPLAYED_UNREAD_COUNT ? OVERFLOW_LABEL : unreadCount}</FlexRow>
        )}
      </Button>
    </div>
  );
};
